import React, { useCallback, useState, useEffect } from "react";

import * as SC from "./AudioLibrary.styled.js";

import logger from "../../../../utils/LoggerFrontend";
import { AudioGenerator } from "./AudioGenerator";
import { AudioTextSamples } from "./AudioTextSamples";
import { DEFAULT_JINGLES, DEFAULT_SOUNDS } from "./AudioGenerator/AudioGenerator.constants.jsx";
import { useTabsContext } from "../../../../context/Tabs.context.jsx";
import { Tabs } from "../../../../Components/Tabs";
import { t } from "i18next";
import { XIcon } from "../../../../Components/Icons";
import { Button } from "../../../../Components/Button";

const AudioLibrary = ({
  orgaId,
  campaignId,
  audioData,
  updateAudioData,
  closeLibrary,
  channel,
  channelData,
  isAutoGenerated,
  autoGeneratedText,
  isAutoGenerationStreaming
}) => {
  logger.debug("AudioLibrary:constructor", "called", { audioData, campaignId });
  const { setActiveTab } = useTabsContext();
  const [url, setUrl] = useState(audioData?.url || "");

  const musicValue = audioData?.music || DEFAULT_JINGLES[0].value;
  const soundValue = audioData?.sound || DEFAULT_SOUNDS[0].value;

  const [music, setMusic] = useState(musicValue);
  const [sound, setSound] = useState(soundValue);
  const [audioText, setAudioText] = useState(audioData?.audioText || "");

  const [useGen, setUseGen] = useState(autoGeneratedText && isAutoGenerated && !audioText);

  const handleAudioUpdate = useCallback(
    ({ key, value }) => {
      logger.log("AudioLibrary:handleAudioUpdate", "called", { key, value });
      if (key === "url") {
        setUrl(value);
      } else if (key === "music") {
        setMusic(value);
      } else if (key === "sound") {
        setSound(value);
      } else if (key === "audioText") {
        setAudioText(value);
      }

      setActiveTab("Generierung");
    },
    [setActiveTab]
  );

  useEffect(() => {
    if (audioData) {
      setUrl(audioData.url);
      setMusic(musicValue);
      setSound(soundValue);
      setAudioText(audioData.audioText);
    }
  }, [audioData, musicValue, soundValue]);

  const saveClicked = useCallback(() => {
    logger.log("AudioLibrary:saveClicked", "render", { url, music, audioText, sound });
    let audioTextFormat = audioText;

    if (isAutoGenerated && autoGeneratedText && !audioText) {
      audioTextFormat = autoGeneratedText || "";
    }

    updateAudioData({
      url: url || "",
      music: music || "",
      sound: sound || "",
      audioText: audioTextFormat || ""
    });
  }, [url, music, sound, audioText, updateAudioData]);

  logger.debug("AudioLibrary:render", "render", { url, music });

  const emitIntercomMessage = () => {
    if (window.Intercom) {
      window.Intercom("showNewMessage", "");
    }
  };

  return (
    <SC.MainWrapper>
      <Tabs
        icon={<XIcon onClick={closeLibrary} />}
        styles={SC.tabsStyles}
        data={[
          {
            key: "Generierung",
            tab: t("Generation"),
            panel: (
              <AudioGenerator
                orgaId={orgaId}
                campaignId={campaignId}
                updateAudioData={handleAudioUpdate}
                url={url}
                music={music}
                sound={sound}
                audioText={audioText}
                channel={channel}
                channelData={channelData}
                isAutoGenerated={isAutoGenerated}
                autoGeneratedText={autoGeneratedText}
                isAutoGenerationStreaming={isAutoGenerationStreaming}
                setUseGen={setUseGen}
                useGen={useGen}
              />
            )
          },
          {
            key: "Alternative",
            tab: "Alternative",
            panel: <AudioTextSamples updateAudioData={handleAudioUpdate} setUseGen={setUseGen} />
          }
        ]}
      />
      <SC.EditorUpdateActions>
        <Button dark variant="secondary" onClick={emitIntercomMessage} text={t("Help")} />
        <Button variant="primary" onClick={saveClicked} text={t("Accept")} />
      </SC.EditorUpdateActions>
    </SC.MainWrapper>
  );
};

export default AudioLibrary;
